// R149 — shared constants + pure helpers for the GuestPasses feature.
// Extracted from the original 539-line GuestPassesCard.jsx so the tree
// stays scan-friendly and each child renders in isolation.

export const HOUR_OPTIONS = [
  { value: "12", label: "12 hours" },
  { value: "24", label: "24 hours" },
  { value: "48", label: "48 hours" },
  { value: "72", label: "72 hours" },
];

export const STATUS_STYLES = {
  active:  "bg-emerald-500/10 border-emerald-500/30 text-emerald-300",
  pending: "bg-amber-500/10 border-amber-500/30 text-amber-300",
  expired: "bg-zinc-500/10 border-zinc-500/30 text-zinc-400",
  revoked: "bg-red-500/10 border-red-500/30 text-red-300",
};

export const DEFAULT_FORM = () => ({
  guest_name: "", plate: "", vehicle_desc: "", hours: "24", notes: "",
  scheduled_start_at: "",
  guest_phone: "",
  custom_note: "",
  recurring: false, pattern: "weekly", days_of_week: [], day_of_month: 15,
  time_of_day: "10:00",
  starts_on: new Date().toISOString().slice(0, 10),
  ends_on: "",
});

export function remaining(validUntil) {
  const ms = new Date(validUntil).getTime() - Date.now();
  if (ms <= 0) return "expired";
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  if (h >= 24) return `${Math.floor(h / 24)}d ${h % 24}h left`;
  if (h >= 1) return `${h}h ${m}m left`;
  return `${m}m left`;
}
